import { render, staticRenderFns } from "./ConfigArrowLeftIcon.vue?vue&type=template&id=70c69e63"
import script from "./ConfigArrowLeftIcon.vue?vue&type=script&lang=js"
export * from "./ConfigArrowLeftIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports